<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <Notification :notify="notify" />
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                id="loginid"
                  prepend-icon="mdi-email"
                  name="email"
                  label="Email"
                  type="text"
                  :rules="emailRules"
                  v-model="email"
                  required
                  v-on:keyup.enter="nextPlease('password')"
                ></v-text-field>
                <v-text-field
                  id="password"
                  prepend-icon="mdi-lock"
                  name="password"
                  label="Password"
                  type="password"
                  v-model="password"
                  :rules="passwordRules"
                  required
                  counter
                  @keyup.enter="login"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="login" id="loginbtn">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script>
import { mapActions } from "vuex";
import Notification from "@/components/Notification";
import * as api from "@/api";

export default {
  name: "Login",
  components: {
    Notification,
  },
  props: {
    source: String,
  },
  methods: {
    ...mapActions(["getLogin"]),
    ...mapActions(["getOrgAdmin"]),
    ...mapActions(["getUserRole"]),
    login() {
      this.$refs.form.validate();
      this.notify.errors.splice(0, this.notify.errors.length);
      if (this.valid) {
        new Promise((resolve, reject) => {
          api
            .login(
              JSON.stringify({ username: this.email, password: this.password, DeviceInfo: { "DeviceID": "Portal", "DeviceName": "Portal", "MACAddress" : "Portal"} })
            )
            .then((response) => {
              resolve(response);
              console.log("a" + response.status);
            })
            .catch((error) => {
              reject(error);
              console.log("b" + error);
              this.notify.type = 4;
              this.notify.errors.push("You are not authorized.");
            });
        })

          .then((response) => {
            console.log(response.status);
            console.log("c" + response.status);
            console.log("c" + JSON.stringify(response.data));
            if (response == undefined) {
              this.notify.type = 4;
              this.notify.errors.push("You are not authorized.");
            } else {
              if (
                response.data.user.userRole === "HubAdmin" ||
                response.data.user.userRole === "PortalAdmin" ||
                response.data.user.userRole === "publisher"
              ) {
              } else {
                this.notify.type = 4;
                this.notify.errors.push("You are not authorized.");
                return;
              }

              console.log(response.data);
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("username", response.data.user.firstName);
              localStorage.setItem("publisher", response.data.user.userRole);
              localStorage.setItem(
                "organizationName",
                response.data.user.organizationName
              );
              localStorage.setItem(
                "organizationId",
                response.data.user.organizationId
              );

              this.getLogin(true);
              this.getOrgAdmin(
                response.data.user.organizationId === 0 ? false : true
              );
              this.getUserRole(response.data.user.userRole);

              //window.location = response.data.user.organizationId === 0  ? "/dashboard" : "/organization/dashboard";

              if (response.data.user.organizationId === 0) {
                if (response.data.user.userRole === "publisher")
                  window.location = "/publisher/publications";
                else window.location = "/dashboard";
              } else window.location = "/organization/dashboard";
            }
          })
          .catch((error) => {
            console.log(error);
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("organizationName");
            localStorage.removeItem("organizationId");
            localStorage.removeItem("publisher");
            reject(error);
          });
      }
    },
    nextPlease: function (event) {
      document.getElementById(event).focus();
    },
  },
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "Password is required",
     /*  (v) => (v && v.length >= 6) || "Name must be less than 6 characters", */
    ],
    notify: {
      type: 0,
      message: "",
      errors: [],
    },
  }),
};
</script>



// WEBPACK FOOTER //
// src/views/Login.vue